function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ServerError } from "../../constants";
import { hasPhoneValidationError, hasServerError, ordinal, numberAndUnit } from "../../infra/utils";
import { RelationshipProgressStatus, RelationshipStatus } from "../../models/relationship";
import { legalTermsModel, serviceModel } from "../../models";
import { notEmpty } from "../../infra/utils";
import { businessSettingsDefaults } from "../../constants";
export function draftToRelationship(draft, relationship) {
  var _draft$services, _relationship$custome, _relationship$buyer, _relationship$vendor, _relationship$seller, _relationship$legalTe;

  return _objectSpread(_objectSpread(_objectSpread({}, draft), relationship), {}, {
    services: ((_draft$services = draft.services) === null || _draft$services === void 0 ? void 0 : _draft$services.map(serviceModel.fromDTO).filter(notEmpty)) || (relationship === null || relationship === void 0 ? void 0 : relationship.services),
    serviceBundles: draft.serviceBundles ? {
      bundles: draft.serviceBundles.bundles.map(b => _objectSpread(_objectSpread({}, b), {}, {
        services: b.services.map(serviceModel.fromDTO).filter(notEmpty)
      }))
    } : undefined,
    amendmentsApprovalMethod: (relationship === null || relationship === void 0 ? void 0 : relationship.amendmentsApprovalMethod) || draft.amendmentsApprovalMethod || businessSettingsDefaults.amendmentsApprovalMethod,
    status: RelationshipStatus.Pending,
    createdOn: 0,
    automaticPaymentsEnabled: !!draft.requirePaymentMethod && !draft.allowManualPayments,
    version: '',
    customer: (_relationship$custome = relationship === null || relationship === void 0 ? void 0 : relationship.customer) !== null && _relationship$custome !== void 0 ? _relationship$custome : {
      id: '',
      name: 'Company name'
    },
    buyer: (_relationship$buyer = relationship === null || relationship === void 0 ? void 0 : relationship.buyer) !== null && _relationship$buyer !== void 0 ? _relationship$buyer : {
      id: '',
      email: '',
      firstName: 'First name',
      lastName: 'Last name',
      phone: draft.buyerPhone
    },
    vendor: (_relationship$vendor = relationship === null || relationship === void 0 ? void 0 : relationship.vendor) !== null && _relationship$vendor !== void 0 ? _relationship$vendor : {
      branding: {
        color: ''
      },
      id: '',
      logoUrl: null,
      name: '',
      stripeAccountId: '',
      postalAddress: {
        addressOne: null,
        addressTwo: null,
        city: null,
        country: null,
        postalCode: null,
        state: null
      }
    },
    signedOn: null,
    terminatedOn: null,
    seller: (_relationship$seller = relationship === null || relationship === void 0 ? void 0 : relationship.seller) !== null && _relationship$seller !== void 0 ? _relationship$seller : {
      id: '',
      email: '',
      firstName: null,
      lastName: null,
      phone: null
    },
    legalTerms: (_relationship$legalTe = relationship === null || relationship === void 0 ? void 0 : relationship.legalTerms) !== null && _relationship$legalTe !== void 0 ? _relationship$legalTe : legalTermsModel.fromDraftLegalTerms(draft.legalTerms),
    paymentMethod: null,
    signature: null,
    approvalFlow: draft.isExistingCustomer ? 'invite' : 'proposal',
    suggestedCustomerName: null,
    invoiceStatus: {
      numPaymentActionRequired: 0,
      numRequiresPaymentApproval: 0
    },
    serviceStatus: {
      numAmended: 0
    },
    progressStatus: RelationshipProgressStatus.Sent,
    progressStatusTimestamp: 0,
    adHocChargeStatus: {
      numAwaitingApproval: 0
    },
    notificationStatus: [],
    createdBy: {
      id: '',
      email: '',
      firstName: '',
      lastName: '',
      phone: null
    },
    changes: null,
    statusTimestamp: 0,
    approvalRecord: {
      ip: '',
      signature: '',
      timestamp: 0
    }
  });
}
export function getCreateRelationshipError(error) {
  return hasServerError(error, ServerError.BuyerUserAssociatedWithVendor) ? {
    id: 'member',
    text: 'Proposals cannot be sent to someone within your own business. Please change contact'
  } : hasPhoneValidationError(error) ? {
    id: 'phone',
    text: 'The proposal was not sent because of an invalid phone number, please verify and send again'
  } : {
    id: 'unknown',
    text: 'An internal error occurred, please contact support for further help.'
  };
}
export function getInfoBoxText(day, isBilledUpfront, netTerms) {
  const isFirstDay = day === 1;
  const isLastDay = typeof day !== 'number';
  const netTermsText = netTerms > 0 ? "Payment will be processed automatically within ".concat(numberAndUnit(netTerms, 'day'), ".") : 'Payment will be processed immediately.';
  let issuedText;

  if (isLastDay) {
    issuedText = 'Invoices will be issued on the last day of each month, billing for that month.';
  } else if (isFirstDay) {
    issuedText = isBilledUpfront ? "Invoices will be issued on the ".concat(ordinal(day), " of each month, billing for the full month in advance.") : "Invoices will be issued on the ".concat(ordinal(day), " of each month, billing for the period that started on the ").concat(ordinal(day + 1), " of the previous month.");
  } else {
    issuedText = isBilledUpfront ? "Invoices will be issued on the ".concat(ordinal(day), " of each month, billing for the period that ends on the ").concat(ordinal(day - 1), " of the following month.") : "Invoices will be issued on the ".concat(ordinal(day), " of each month, billing for the period that started on the ").concat(ordinal(day + 1), " of the previous month.");
  }

  return [issuedText, netTermsText];
}
export const billingDayOfMonthToValue = _ref => {
  let {
    type,
    day
  } = _ref;
  return JSON.stringify([type, day]);
};
export const valueToBillingDayOfMonth = value => {
  const [type, day] = JSON.parse(value);
  return {
    type,
    day
  };
};
export const defaultCoverLetterNewClient = "We've created an agreement in Anchor, a billing platform that we use to automate the payment process so both of us can save time and effort.\n\nIt includes a detailed description of the services we agreed on, the price, and the billing terms.\n\nPlease review and approve the agreement.";
export const defaultCoverLetterExistingClient = "We've created a new agreement in Anchor, a billing platform that we use to automate the payment process so both of us can save time and effort.\n\nIt includes a detailed description of the services we agreed on, the price, and the billing terms.\n\nPlease review and approve the agreement.";
export function contactHasAgreement(contact, agreements, proposals) {
  if (!contact.customerId) return false;

  const hasContact = r => !r.isSample && r.customer.id === contact.customerId;

  return !!agreements && agreements.some(hasContact) || !!proposals && proposals.some(hasContact);
}